// Ported from files/snapdraw-design-kit/code/src/lib/i18n/strings/catalog.ts.
// Backlog G4 (2026-08-24): real catalog CRUD replaces the earlier stub —
// Assembly dropped as a category (DESIGN-SPEC.md §12.1: "An assembly is
// just several lines on a quote"); item-sheet/picker copy lives in the
// new src/lib/i18n/strings/lineitems.ts alongside the other new pieces
// of this same system.
export const en = {
  "catalog.eyebrow": "Pricing Library",
  "catalog.title": "Rate Catalog",
  "catalog.subtitle": "Materials & equipment are costs — your markup gets added at quote time. Labor rates are billed as-is.",
  "catalog.newItem": "New Item",
  "catalog.searchPlaceholder": "Search codes, items…",
  "catalog.category.all": "All",
  "catalog.category.labor": "Labor",
  "catalog.category.material": "Material",
  "catalog.category.equipment": "Equipment",
  "catalog.col.code": "Code",
  "catalog.col.item": "Item",
  "catalog.col.category": "Category",
  "catalog.col.unit": "Unit",
  "catalog.col.rate": "Rate",
  "catalog.col.used": "Used",
  "catalog.loading": "Loading catalog items",
  "catalog.empty.title": "Catalog is empty",
  "catalog.empty.body": "Save the rates you quote most — journeyman hours, conduit, panels — and reuse them on every quote.",
  "catalog.perUnit": "per",
  "catalog.usedSuffix": "× USED",
} as const;

export const es: Record<keyof typeof en, string> = {
  "catalog.eyebrow": "Biblioteca de precios",
  "catalog.title": "Catálogo de tarifas",
  "catalog.subtitle": "Materiales y equipo son costos — tu margen se agrega al cotizar. Las tarifas de mano de obra se cobran tal cual.",
  "catalog.newItem": "Nuevo ítem",
  "catalog.searchPlaceholder": "Buscar códigos, ítems…",
  "catalog.category.all": "Todos",
  "catalog.category.labor": "Mano de obra",
  "catalog.category.material": "Material",
  "catalog.category.equipment": "Equipo",
  "catalog.col.code": "Código",
  "catalog.col.item": "Ítem",
  "catalog.col.category": "Categoría",
  "catalog.col.unit": "Unidad",
  "catalog.col.rate": "Tarifa",
  "catalog.col.used": "Usado",
  "catalog.loading": "Cargando ítems del catálogo",
  "catalog.empty.title": "El catálogo está vacío",
  "catalog.empty.body": "Guarda las tarifas que más cotizas — horas de oficial, conduit, paneles — y reúsalas en cada cotización.",
  "catalog.perUnit": "por",
  "catalog.usedSuffix": "× USADO",
};
